import { render, staticRenderFns } from "./HeaderDesktop.vue?vue&type=template&id=5ed9e828&scoped=true&"
import script from "./HeaderDesktop.vue?vue&type=script&lang=ts&"
export * from "./HeaderDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderDesktop.vue?vue&type=style&index=0&id=5ed9e828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9e828",
  null
  
)

export default component.exports